// GET on a wizard entry creates a draft server-side, so Turbo's hover/touch prefetch must not fire for it
// (feed promo cards link to /ads/new and were minting a draft per viewer).
const DRAFT_CREATING_PATH = /^\/(ads|listings|products)\/new\/?$/

export function createsDraftOnVisit(url) {
  return DRAFT_CREATING_PATH.test(url.pathname)
}

export function installWizardPrefetchGuard(doc = document) {
  doc.addEventListener("turbo:before-prefetch", (event) => {
    const href = event.target?.href
    if (!href) return

    try {
      if (createsDraftOnVisit(new URL(href))) event.preventDefault()
    } catch {
      // Unparseable href: leave Turbo's default behaviour
    }
  })
}
